import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Variant } from '../models';

@Component({
  selector: 'app-variant',
  templateUrl: './variant.component.html',
  styleUrls: ['./variant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariantComponent implements OnInit {
  @Input() variant: Variant;

  constructor() { }

  ngOnInit() {
    // console.log(this.variant);
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/variant/variant.component.ts